import * as React from 'react';
import {
  Box,
  Container,
  Grid,
  makeStyles,
  Typography,
} from '@material-ui/core';
import Image from 'next/image';
import membersImg from '../../../../public/assets/icons/members.svg';
import reportImg from '../../../../public/assets/icons/report.svg';
import priceImg from '../../../../public/assets/icons/price.svg';
import CurrencyFormat from '../../../../services/CurrencyFormat';

const useStyles = makeStyles((theme) => ({
  introBg: {
    width: '100%',
    margin: '50px auto',
    padding: '30px',
    backgroundColor: 'none',
    textAlign: 'center',
    borderRadius: '20px',
    marginTop: '450px',
    [theme.breakpoints.down('sm')]: {
      padding: 0,
      textAlign: 'left',
    },
  },
  t1: {
    fontFamily: 'Vazir-Bold',
    fontSize: '20px',
    marginTop: '10px',
  },
  t2: {
    fontFamily: 'Vazir !important',
    fontSize: '20px',
  },
  t3: {
    textAlign: 'center',
    fontSize: '20px',
    fontFamily: 'Vazir-Bold',
    marginBottom: '50px',
  },
  bord: {
    [theme.breakpoints.up('sm')]: {
      borderRight: 'solid 2px #bbb',
    },
    [theme.breakpoints.down('sm')]: {
      borderBottom: 'solid 2px #bbb',
      padding: '20px 0',
    },
  },
  noBord: {
    [theme.breakpoints.down('sm')]: {
      padding: '20px 0',
    },
  },
  blueLine: {
    display: 'inline-block',
    borderBottom: 'solid 3px #29ade9',
    width: 'max-content',
  },
  icon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      alignItems: 'left',
      justifyContent: 'left',
    },
  },
  iconTitle: {
    marginTop: '30px',
    paddingLeft: '10px',
    fontFamily: 'Vazir-Bold',
    fontSize: '20px',
  },
  icons: {
    width: '70px',
    [theme.breakpoints.down('sm')]: {
      width: '50px',
    },
  },
}));

const Statistics = ({ userCount, totalPrice, reportCount }) => {
  const classes = useStyles();

  return (
    <>
      <Container>
        <div className={classes.introBg}>
          <Grid container>
            <Grid item xs={12} md={4} className={classes.bord}>
              <Container className={classes.icon}>
                <Box style={{ width: '70px' }}>
                  <Image
                    src={membersImg}
                    alt="details"
                    style={{ width: '100%' }}
                  />
                </Box>
                <Typography className={classes.iconTitle}>
                  <span className={classes.t2}>
                    {' '}
                    {userCount ? Number(userCount) : 0}{' '}
                  </span>
                  نفر
                </Typography>
              </Container>
              <Typography className={classes.t1}>
                تعداد کاربران مشارکت کننده تا امروز
              </Typography>
            </Grid>
            <Grid item xs={12} md={4} className={classes.bord}>
              <Container className={classes.icon}>
                <Box style={{ width: '70px' }}>
                  <Image
                    src={priceImg}
                    alt="details"
                    style={{ width: '100%' }}
                  />
                </Box>
                <Typography className={classes.iconTitle}>
                  <span className={classes.t2}>
                    {' '}
                    {totalPrice
                      ? CurrencyFormat(Number(totalPrice) / 10)
                      : 0}{' '}
                  </span>
                  تومان
                </Typography>
              </Container>
              <Typography className={classes.t1}>
                جمع کمک‌های انجام شده تا امروز{' '}
              </Typography>
            </Grid>
            <Grid item xs={12} md={4}>
              <Container className={classes.icon}>
                <Box style={{ width: '70px' }}>
                  <Image
                    src={reportImg}
                    alt="details"
                    style={{ width: '100%' }}
                  />
                </Box>
                <Typography className={classes.iconTitle}>
                  <span className={classes.t2}>
                    {' '}
                    {reportCount ? Number(reportCount) : 0}{' '}
                  </span>
                  موسسه
                </Typography>
              </Container>
              <Typography className={classes.t1}>
                تعداد موسسات مشارکت‌کننده{' '}
              </Typography>
            </Grid>
          </Grid>
        </div>
      </Container>
    </>
  );
};

export default Statistics;
